module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    staticClass: "devices-list"
  }, [_vm._l((_vm.devices), function(item) {
    return [_c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": "",
        "append": ""
      },
      on: {
        "click": function($event) {
          return _vm.openDevice(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "color": _vm.$ponceConfig.checkStatus(item.Event ? item.Event.State.value : _vm.STATES.OFF)
      }
    }, [_vm._v("trip_origin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('strong', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.getName(item))
      }
    })], 1), _vm._v(" "), (item.Crops.length) ? _c('v-list-tile-sub-title', {
      staticClass: "device-lot-name"
    }, [_vm._v(_vm._s(item.Crops[0].name))]) : _c('v-list-tile-sub-title', {
      staticClass: "device-lot-name"
    }, [_vm._v("Sin Lote")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("arrow_forward_ios")])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35309f78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/DevicesList.vue
// module id = 765
// module chunks = 7